"use client"
import { getDisclaimer } from "@/app/utils/request/requestList";
import { GET_DISCLAIMER} from '../utils/request/query';
import { useEffect, useState } from "react";
import styled from "styled-components";
import React from 'react';
import { useLanguage } from "../utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize";

const DivDisclaimer = styled("div")<{ $fontSize?: number }>(({ $fontSize }) => ({
    ...textSize($fontSize ? $fontSize : 11),
    fontWeight: 500
}));

interface propType {
    type?: string;
    fontSize?: number;
    disclaimerType?: string; // default: general; carnival
}

const Disclaimer: React.FC<propType> = (props: propType) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [disclaimerData, setDisclaimerData] = React.useState('');

    useEffect(() => {
        getDisclaimer({
            language: lang.langCode,
        }, GET_DISCLAIMER, "cms", props.disclaimerType == "carnival").then((res) => {
            setDisclaimerData(res?.item?.disclaimer?.value || '');
        });
    }, []);

    return (
        <> {
            disclaimerData === '' ? <></>
            : <DivDisclaimer $fontSize={props.fontSize}>
                <div id="disclaimer_title">{t('disclaimer')}</div>
                <div id="disclaimer_content" dangerouslySetInnerHTML={{ __html: disclaimerData }}></div>
            </DivDisclaimer>
        }
        </>
    )
}

export default Disclaimer; 